/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sv } from './Sv';

class Courseware extends Sv {
    constructor() {
        super();
        this.baseUrl += '/courseware';
    }

    data({ courseName, coursewareCatId, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            courseName,
            coursewareCatId,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { fileBasePath } = json.data.data;
            const { courseVoiceFile, courseType, courseFile } = json.data.data.courseware;
            if (!courseVoiceFile) {
                json.data.data.courseware.courseVoiceFile = [];
            } else {
                json.data.data.courseware.courseVoiceFile = courseVoiceFile.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            if (+courseType === 1) {
                json.data.data.courseware.courseFile1 = courseFile;
            }
            if (+courseType === 2) {
                json.data.data.courseware.courseFile2 = courseFile.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            if (+courseType === 3) {
                json.data.data.courseware.courseFile3 = courseFile.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            if (+courseType === 4) {
                const courseFileData = JSON.parse(courseFile);
                json.data.data.courseware.courseFile4 = courseFileData.pdfFile.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({
        id,
        courseName,
        courseType,
        courseFile1,
        courseFile2,
        courseFile3,
        courseFile4,
        courseVoiceFile,
        courseDesc,
        isAvailable,
        coursewareCatId,
    } = {}) {
        let courseFileStr = '';
        if (+courseType === 1) {
            courseFileStr = courseFile1;
        }
        if (+courseType === 2) {
            courseFileStr = courseFile2
                .reduce((prev, curr) => {
                    prev.push(curr.name);
                    return prev;
                }, [])
                .join(',');
        }
        if (+courseType === 3) {
            courseFileStr = courseFile3
                .reduce((prev, curr) => {
                    prev.push(curr.name);
                    return prev;
                }, [])
                .join(',');
        }
        if (+courseType === 4) {
            courseFileStr = courseFile4
                .reduce((prev, curr) => {
                    prev.push(curr.name);
                    return prev;
                }, [])
                .join(',');
        }
        const courseVoiceFileStr = courseVoiceFile
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post(
            '/save',
            {
                id,
                courseName,
                courseType,
                courseFile: courseFileStr,
                courseVoiceFile: courseVoiceFileStr,
                courseDesc,
                isAvailable,
                coursewareCatId,
            },
            { timeout: 0 },
        );
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }
}

export default new Courseware();
export { Courseware };
